// Translation Store

const state = {
  pendingTranslations: false,
}

const getters = {}

const actions = {
  togglePendingTranslations({ commit }) {
    commit('TOGGLE_PENDING_TRANSLATIONS')
  },
}

const mutations = {
  TOGGLE_PENDING_TRANSLATIONS: state => {
    state.pendingTranslations = !state.pendingTranslations
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
